import React, { useEffect, useState } from 'react';
import ContainerBlur from '@components/navigation/ContainerBlur';
import { NotificationItemProps } from '@components/navigation/notification/NotificationItem';
import moment from 'moment';
import NotificationContainer from '@components/navigation/notification/NotificationContainer';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { useNotifications } from '@hooks/user.hook';
import { NotificationIcon } from '@components/navigation/notification/GetNotificationIconName';
import { NotificationAction } from '@components/navigation/notification/GetNotificationAction';
import { useNavigate } from 'react-router-dom';
import { CDN_URL } from '@utils/constants/url.constants';
import { NOTIFICATION_TYPE } from '@utils/constants/notification.constant';
import { useParams } from 'react-router-dom';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';

export interface NotificationProps {
  onClose: () => void;
  onOpen: () => void;
}
const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const Notification = (props: NotificationProps) => {
  const viewWidth = useViewWidth();
  const notifications = useNotifications(10);
  const [notificationItems, setNotificationItems] = useState<
    NotificationItemProps[]
  >([]);
  const navigate = useNavigate();
  // for now let's just use this state until we find the problem about why isFetchingNextPage always false in react query v4
  const [isFetchNext, setIsFetchNext] = useState(false);

  const params = useParams();

  const notificationToHide = [
    NOTIFICATION_TYPE.NOTIFICATION_LEADERBOARD,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_SENT,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_RECEIVED,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_ACCEPTED,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_COMPLETED,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_REWARD_SHARER,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_REWARD_RECEIVER,
    NOTIFICATION_TYPE.NOTIF_CHALLENGE_RECEIVER_COMPLETED,
    NOTIFICATION_TYPE.NOTIFICATION_PROGRESS_REPORT,
    NOTIFICATION_TYPE.NOTIF_ANSWER_COMMENTED,
    NOTIFICATION_TYPE.NOTIF_BUBBLE_WS_COMPLETE,
    NOTIFICATION_TYPE.NOTIFICATION_GENIEASK_TEACHER_PINNED,
  ];

  useEffect(() => {
    pushData();
  }, [notifications.data?.pages]);

  useEffect(() => {
    props.onOpen();
  }, []);

  function pushData() {
    const toPush = notifications.data?.pages;
    const notification: NotificationItemProps[] = [];

    if (Array.isArray(toPush)) {
      for (let i = 0; i < toPush.length; i++) {
        const page = toPush[i];
        for (let j = 0; j < page.length; j++) {
          if (
            notificationToHide.filter(
              item => item == parseInt(page[j].notification_type),
            ).length > 0
          ) {
            continue;
          }

          if (
            parseInt(page[j].notification_type) ==
              NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_INCREASED ||
            parseInt(page[j].notification_type) ==
              NOTIFICATION_TYPE.NOTIFICATION_MASTERY_LEVEL_DECREASED
          ) {
            page[j].subject_id = subjectIdFromName(params.subjectId ?? '');
          }

          notification.push({
            id: page[j].notification_id,
            title: page[j].notification_title,
            description: page[j].notification_text,
            date: moment.parseZone(page[j].date_display + '+08:00'), // parse zone from SGT. Will later calculated to local time automatically
            icon: (
              <img
                className={'w-8'}
                src={
                  `${CDN_URL}assets/icons/notification/` +
                  NotificationIcon(
                    parseInt(page[j].notification_type),
                    page[j]?.value_1,
                  )
                }
                alt={''}
              />
            ),
            action: NotificationAction(
              parseInt(page[j].notification_type),
              navigate,
              page[j].worksheet_id,
              page[j].subject_id,
              page[j].online_lesson_id,
              page[j].class_name,
              page[j].url,
            ),
            close: props.onClose,
            isClicked: !!page[j].date_clicked,
          });
        }
      }
    }

    setNotificationItems(notification);
  }

  async function fetchNext() {
    setIsFetchNext(true);
    await notifications.fetchNextPage();
    setIsFetchNext(false);
  }

  return viewWidth < breakpoint.md ? (
    <div
      className={'fixed left-0 top-0 h-full w-full z-[999] bg-neutral-chalk'}
    >
      <NotificationContainer
        notificationItems={notificationItems}
        onClose={props.onClose}
        loading={notifications.isLoading}
        loadingNext={isFetchNext}
        onNextFetch={fetchNext}
        isError={notifications.isError}
      />
    </div>
  ) : (
    <>
      <ContainerBlur
        clickaway={props.onClose}
        className={
          'cursor-auto !pt-2 !pb-0 !px-2 !backdrop-blur-0 !bg-neutral-chalk !overflow-hidden'
        }
      >
        <NotificationContainer
          notificationItems={notificationItems}
          onClose={props.onClose}
          loading={notifications.isLoading}
          loadingNext={isFetchNext}
          onNextFetch={fetchNext}
          isError={notifications.isError}
        />
      </ContainerBlur>
    </>
  );
};

export default Notification;
